export enum PAYWALLS_STATUS {
  LOADING = 'LOADING',
  NOT_ENABLED = 'NOT_ENABLED',
  ENABLED_AND_NOT_SETUP = 'ENABLED_AND_NOT_SETUP',
  ENABLED_AND_SETUP = 'ENABLED_AND_SETUP',
}

export type PaywallPrice = {
  currencyCode: string;
  isPromotedTier: boolean;
  name: string;
  webPriceId: string;
  unitAmount: number;
  webPriceTierId: string;
};

export type PaywallMetadata = {
  isSubscriptionEnabled: boolean;
  price: PaywallPrice;
  listenerMessage?: string;
  creatorRssUrl?: string;
  creatorSpotifyAuthUrl?: string;
  disableOn?: string;
};

export type DistributionEligibilityForPaywalls =
  | 'eligible'
  | 'error_spotify_exclusive'
  | 'error_no_spotify_uri'
  | 'no_taxi_distribution';

export type Metadata = {
  authorEmail?: string;
  authorName?: string;
  doEnableListenerSupportLinkInEpisodes?: boolean;
  doHideDefaultAdSlotsInEpisodes?: boolean;
  feedUrl?: string;
  hasAnchorBranding?: boolean;
  hasEverEnabledSponsorships?: boolean;
  hasSeenSponsorshipsReminderModal?: boolean;
  isFirstTimeCreator?: boolean;
  isPWEnabled?: boolean;
  isPWSetup?: boolean;
  isPublicCallinShownOnWeb?: boolean;
  isUserEmailInRss?: boolean;
  itunesCategory?: string;
  language?: string;
  podcastLanguage?: string;
  podcastCategory?: string;
  listenerSupportCustomMessage?: string;
  podcastDescription?: string;
  podcastImage?: string;
  podcastImageFull?: string;
  podcastName?: string;
  safePodcastDescription?: string;
  userBioUrl?: string;
  userEmail?: string;
  vanitySlug?: string;
  webStationId?: string;
  hasDismissedDistributionMilestone?: boolean;
  isExplicit?: boolean;
  defaultProfileHeaderColor?: string;
  profileHeaderColor?: string;
  podcastExternalSource?: string;
  stationPaywall?: PaywallMetadata;
  monetizationConfirmedCountry?: string;
  hasAcceptedTOSMonetization?: boolean;
  podcastExternalSourceRedirected?: string;
  podcastExternalSourceExpired?: string;
  distributionEligibilityForPaywalls?: DistributionEligibilityForPaywalls;
  spotifyDistributionStatus?: string;
  isMusicAndTalkFastTrackEnabled?: boolean;
  hasDismissedMonetizationMilestone?: boolean;
};
